// Lista de espera: reglas puras compartidas por el formulario, el link de baja y el link de reserva.

/** Query param que lleva el token del aviso hasta la reserva pública (sobrevive al login y a recargar). */
export const WAITLIST_PARAM = "waitlist";

export const waitlistTokenFromSearch = (search) => {
  try {
    return new URLSearchParams(search || "").get(WAITLIST_PARAM) || "";
  } catch (_) {
    return "";
  }
};

/** Datos de la anotación que el aviso deja en el `state` de la navegación: { date, time, criteria }. */
export const waitlistPrefill = (state) => {
  const value = state?.waitlist;
  return value && typeof value === "object" ? value : null;
};

/** El local activó la lista de espera (Políticas > reminders.waitlist). Tolera una bandera plana. */
export const isWaitlistEnabled = (venue) =>
  Boolean(venue && (venue.waitlistEnabled === true || venue.reminders?.waitlist?.enabled === true));

export const WINDOW_OPTIONS = [
  { value: "", label: "Cualquiera" },
  { value: "morning", label: "Mañana" },
  { value: "afternoon", label: "Tarde" },
  { value: "evening", label: "Noche" },
];

const KIND_BASE = { beauty: "/beauty", court: "/canchas", club: "/canchas", table: "/reservas", bar: "/reservas" };

/** Ruta pública de reserva del local del aviso, con el token y la selección precargados. */
export const claimDestination = (claim, token) => {
  const venue = claim?.venue || {};
  const base = KIND_BASE[venue.kind] || KIND_BASE[claim?.entry?.kind];
  const ref = venue.slug || venue.id || venue._id || claim?.entry?.barId;
  if (!base || !ref) return null;
  const to = `${base}/${encodeURIComponent(ref)}?${WAITLIST_PARAM}=${encodeURIComponent(token)}`;
  return {
    to,
    state: {
      date: claim.entry?.date,
      waitlist: { date: claim.entry?.date, time: claim.slotStart, criteria: claim.entry?.criteria || {} },
    },
  };
};

/** Mensaje para el usuario según el error de anotarse: el del back en 400, genérico en el resto. */
export const joinErrorMessage = (err) => {
  const code = err?.response?.status;
  if (code === 400) return err.response.data?.message || "Revisá los datos e intentá de nuevo.";
  if (code === 403) return "Este local no tiene la reserva online disponible.";
  if (code === 404) return "No encontramos este local.";
  return "No pudimos anotarte. Probá de nuevo en unos segundos.";
};
